module.exports = __webpack_public_path__ + "static/media/hypokaustenheizung1.d80e7cad.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/hypokaustenheizung1.JPG
// module id = 769
// module chunks = 0